import popup from './popup';
import {iphone} from "inputmask/lib/environment";
import { UAParser } from 'ua-parser-js'

// заменить на относительный путь и проверить другие места перед релизом
const redirectURI = `https://${location.host}/auth/complete.php`;
const URISendState = `https://${location.host}/auth/front.php?state=`;
const clientId = 'cloud_payments_application_gray';
const SSOUrl = location.host === 'cloudpayments-cloudpayments.linestest.com' ? 'id-qa.tcsbank.ru' : 'id.tinkoff.ru';

let ssoFrame = null;
let ssoFrameElement = null;
let state = null;
let timer = null;
let checkOutTimer = null;
let token = null;
let callbackSend = null;
let currentForm = null;
let formSubmitted = false;
let isFrameInit = false;
let fallbackInput = null;

function reset() {
	ssoFrame = null;
	ssoFrameElement = null;
	state = null;
	timer = null;
	token = null;
	callbackSend = null;
	currentForm = null;
	formSubmitted = false;

	if (fallbackInput) {
		fallbackInput.remove();
	}

	fallbackInput = null;
}

function generateToken(length) {
	let a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
	let b = [];
	for (let i = 0; i < length; i++) {
		let j = (Math.random() * (a.length - 1)).toFixed(0);
		b[i] = a[j];
	}

	return b.join('');
}

function setHeight(height) {
	ssoFrameElement.style.height = `${height}px`;
}

function createInput(name, value, type) {
	const input = document.createElement('input');
	input.type = type;
	input.name = name;
	input.value = value;

	if (type === 'hidden') {
		input.classList.add('is-hidden');
	}

	currentForm.appendChild(input);

	return input;
}

function addInputToken() {
	const oldInput = currentForm.querySelector('[name="token"]');

	if (oldInput) {
		oldInput.value = token ? token : '';

		return;
	}

	createInput('token', token ? token : 'test', 'hidden');

	// const input = document.createElement('input');
	// input.type = 'hidden';
	// input.name = 'token';
	// input.value = token ? token : 'test';
	// input.classList.add('is-hidden');
	// currentForm.appendChild(input);
}

function closeFrame() {
	// eslint-disable-next-line no-use-before-define
	window.removeEventListener('message', eventHandler);
	ssoFrame.remove();
	// currentForm.classList.remove('is-hidden');
}

function createFallBackInput() {
	const { browser } = UAParser(window.navigator.userAgent);
	console.log('back');

	window.removeEventListener('hashchange', createFallBackInput);
	closeFrame();
	if (browser.name === "Chrome") {
		// Костыль
		const phoneErrText = '<label id="phoneResident-error" class="error" for="phoneResident">Неверно указан телефон</label>';
		const phone = $('#phoneResident');
		const phoneErr = $('.error#phoneResident-error');

		if (phoneErr.length === 0) {
			phone.after(phoneErrText);
			phone.addClass('error');
		}
		else {
			phone.addClass('error');
			phoneErr.css("display","block");
			phoneErr.text("Неверно указан телефон");
		}
		currentForm.classList.remove('is-hidden');

		return;
		//
	}

	if (!fallbackInput) {
		fallbackInput = createInput('fallback', 'true', 'hidden');
	}

	callbackSend();
}

function errorHandler(payload) {
	if (payload === 'error' || payload === 'popup' || payload === undefined) {
		if (payload === 'popup') {
			closeFrame();
			popup.openPopup('<p><b>Что-то пошло не так</b></p><p>Уже исправляем неполадки. <br class="for-desktop">Попробуйте зайти на страницу позже.</p>');
		} else {
			createFallBackInput();
		}
	}
}

function setFrameInit() {
	console.log('setFrameInit');

	if (!isFrameInit) {
		isFrameInit = true;
		window.removeEventListener('hashchange', createFallBackInput);
		history.back();
		console.log('init farme');
	} else {
		console.log('repeat function setFrameInit');
	}
}

function sendCodAndState(payload) {
	if (payload !== 'complete') {
		return;
	}

	checkOutTimer = setTimeout(() => {
		if (token) {
			clearInterval(checkOutTimer);

			return;
		}

		clearInterval(timer);
		errorHandler('popup');
	}, 15000);

	timer = setInterval(() => {
		if (!token) {
			fetch(`${URISendState}${state}`).then((res) => {
				const result = res.json();

				return result;
			}).then((res) => {
				if (res.token && !formSubmitted) {
					formSubmitted = true;
					closeFrame();
					clearInterval(timer);
					clearInterval(checkOutTimer);

					token = res.token;
					addInputToken();
					callbackSend(token);
					console.log('send-form');
				}
			}).catch((error) => {
				// eslint-disable-next-line no-console
				console.log(error);
				clearInterval(timer);
				clearInterval(checkOutTimer);
				errorHandler('popup');
			});
		} else {
			clearInterval(timer);
		}
	}, 100);
}

function createFrame() {
	let phone = currentForm.querySelector('[name="phoneNumber"]').value.replace(/[() -]/g, '');
	// add new step to browser history
	history.pushState(null, '', `${location.href}#authorize`);
	// follow the url changes for the history.back search
	window.addEventListener('hashchange', createFallBackInput);

	state = generateToken(30);
	ssoFrameElement = document.createElement('iframe');
	ssoFrame = document.createElement('div');
	ssoFrame.classList.add('sso-wrapper');
	ssoFrame.appendChild(ssoFrameElement);
	ssoFrameElement.src = `https://${SSOUrl}/auth/authorize?theme=cloud-payments&client_id=${clientId}&phone=${Number(phone.replace('+', ''))}&redirect_uri=${redirectURI}&response_type=code&state=${state}&post_complete_redirect_uri=https://${SSOUrl}/common/auth/complete.html`;
	currentForm.parentNode.appendChild(ssoFrame);

	currentForm.classList.add('is-hidden');
}

function openForm() {
	currentForm.classList.remove('is-hidden');
}
function eventHandler(e) {
	if (e.origin !== `https://${SSOUrl}`) {
		return;
	}
	switch (e.data.type) {
		case 'height-change':
			setHeight(e.data.offsetHeight);
			break;

		case 'sso-initialized-form-name':
			// checking the creation of the form
			setFrameInit();

			sendCodAndState(e.data.payload);
			// if payload error
			errorHandler(e.data.payload);
			break;

		case 'sso-otp-cancel':
			openForm();
			closeFrame();
			break;

		case 'error':
			errorHandler('fallback');
			break;

		// eslint-disable-next-line no-fallthrough
		default:
			break;
	}
}

function init(form, callback) {
	if (form.querySelector('[name="nonResident"]')) {
		callback();

		return;
	}

	reset();

	callbackSend = callback;
	currentForm = form;

	setTimeout(() => {
		window.addEventListener('message', eventHandler);
		createFrame();
	}, 100);
}

export default {
	init,
	createFrame,
};

